import { ITheme } from "../../utils/theme"

export const tableHeaderSTyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold',
  marginTop: 4,
  marginBottom: 1,
}
